import MXTable from './components/MXTable'
import MXFilter from './components/MXFilter'
import DynamicForm from './components/dynamicForm/'
import WorkteamProcess from './components/WorkteamProcess'
import iconFont from './components/icon-font'
import MXImage from './components/MXImage'
import PageHeader from './components/PageHeader.vue';
import xwLabelValue from './components/xw-label-value'
import xwModal from './components/xw-modal'
import xwPrice from './components/xw-price'
import MXSortTable from './components/MXSortTable.vue'
import MXMoreFilter from './components/MXMoreFilter.vue'
import DynamicMoreForm from './components/dynamicMoreForm/'
import xwDrawer from './components/xw-drawer.vue'
import xwFlow from './components/xw-flow.vue'
import MXUploadCard from './components/MXUploadCard.vue'
import xwTTable from './components/xw-t-table.vue'
import MXStatusTabs from './components/MXStatusTabs.vue'

export default function (Vue) {
  Vue.component('MXTable', MXTable)
  Vue.component('MXFilter', MXFilter)
  Vue.component('DynamicForm', DynamicForm)
  Vue.component('WorkteamProcess', WorkteamProcess)
  Vue.component('iconFont', iconFont)
  Vue.component('MXImage', MXImage)
  Vue.component('PageHeader', PageHeader)
  Vue.component('xw-label-value', xwLabelValue)
  Vue.component('xw-modal', xwModal)
  Vue.component('xw-price', xwPrice)
  Vue.component('MXSortTable', MXSortTable)
  Vue.component('MXMoreFilter', MXMoreFilter)
  Vue.component('DynamicMoreForm', DynamicMoreForm)
  Vue.component('xw-drawer', xwDrawer)
  Vue.component('xw-flow', xwFlow)
  Vue.component('MXUploadCard', MXUploadCard)
  Vue.component('xw-t-table', xwTTable)
  Vue.component('MXStatusTabs', MXStatusTabs)
}
